module.exports = __webpack_public_path__ + "img/passwordHideIcon.a55d354f.svg";